module.exports = __webpack_public_path__ + "img/login-very-berry.f4b9665e.jpg";